import { Checkbox, Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps, HiddenAttributes } from "../../types/types";

export const HiddenCheckboxField: FieldMethod = ({ field, rules }: FormFieldFactoryProps) => {
    const attributes = field.attributes as HiddenAttributes;

    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules} hidden initialValue={attributes.defaultValue}>
            <Checkbox type="hidden" disabled={false} />
        </Form.Item>
    );
};
